import { render, staticRenderFns } from "./BorrowerLoan.vue?vue&type=template&id=1030acf5&"
import script from "./BorrowerLoan.vue?vue&type=script&lang=js&"
export * from "./BorrowerLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports